import { useConfirmationModal } from "./hooks/useConfirmationModal";
import { ConfirmExitDialogProps } from "./CustomModelsCreation/CustomParameters/types";

import { ConfirmationModal, ConfirmationModalVariant } from "@/components/ConfirmationModal";

export const ConfirmExitDialog = ({
  isSubmitted,
  setIsSubmitted,
  setIsConfirmationModalOpen,
  isConfirmationModalOpen,
  reset,
  isNavigatingBack = false,
  onDiscardBack,
}: ConfirmExitDialogProps) => {
  const {
    onConfirmation,
    confirmLabel,
    leaveLabel,
    confirmTitle,
    confirmDescription,
    handleClose,
  } = useConfirmationModal({
    isSubmitted,
    setIsSubmitted,
    setIsConfirmationModalOpen,
    isConfirmationModalOpen,
    isNavigatingBack,
  });

  return (
    <ConfirmationModal
      title={confirmTitle}
      description={confirmDescription}
      isOpen={isConfirmationModalOpen}
      setIsOpen={setIsConfirmationModalOpen}
      headerVariant={ConfirmationModalVariant.warning}
      leaveButtonText={leaveLabel}
      saveButtonText={confirmLabel}
      handleOnConfirm={onConfirmation}
      handleLeave={() => {
        if (isNavigatingBack) {
          onDiscardBack?.();
          return;
        }

        reset();
      }}
      handleClose={handleClose}
    />
  );
};
